/**
 * Listan bakom en rad i Kräver åtgärd.
 * Samma widget som tidigare, så registreringsnumret fortfarande öppnar bilen.
 */

import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '@/store/languageStore';
import type { ActionKind } from '@/utils/actionRequired';
import InspectionDueWidget from './InspectionDueWidget';
import LeasingExpiringWidget from './LeasingExpiringWidget';
import TaxDueWidget from './TaxDueWidget';

function DetailBody({ kind }: { kind: Exclude<ActionKind, 'service'> }) {
  if (kind === 'inspection') return <InspectionDueWidget startExpanded />;
  if (kind === 'leasing') return <LeasingExpiringWidget startExpanded />;
  return <TaxDueWidget startExpanded />;
}

const ActionRequiredDetail: React.FC<{ kind: Exclude<ActionKind, 'service'>; onClose: () => void }> = ({ kind, onClose }) => {
  const { t } = useTranslation();

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/50 p-4 sm:p-8" onClick={onClose}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label={t(`actionRequired.${kind}`)}
        className="relative mt-8 w-full max-w-3xl rounded-xl border border-borderDefault bg-bgCard p-4 shadow-xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 rounded-lg p-1 text-textTertiary hover:bg-bgHover"
          aria-label={t('common.close')}
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
        <div className="pr-8">
          <DetailBody kind={kind} />
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default ActionRequiredDetail;
